// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bc7402cd","455":"89ad7ffd","977":"de99266b"}[chunkId] + ".chunk.js";
};